@if (content) {
<div class="overflow-hidden"
     [class._is-transparent]="pageHeaderTransparent">
    @switch (content.header_type) {
    @case ('standard') {
    @if (client.isCms || (content.display_image && content.image)) {
    <div [ngClass]="content.image_ratio || 'ratio-6-1'">
        @if (content.display_image && content.image) {
        <img [dfImage]="content.image"
             [priority]="content.cwvLoading === 'eager' || content.cwvPriority"
             [ratio]="content.image_ratio || 'ratio-6-1'"
             [alt]="category.name"
             fill>
        }
        <div class="flex flex-middle flex-justify-center fill z-2">
            <h1 class="h2 p-b-2 p-l-2">{{category.name | facetOverride : category.id : 'h1'}}</h1>
        </div>
    </div>
    }
    }
    @case ('content') {
    @if (content.category_components) {
    <icms-outlet [components]="content.category_components"
                 [name]="'Category components'" />
    }
    }
    }
</div>
}